var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAveiro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "santa-maria-feira_00000085215004630643680740000016694645643676678273_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 180",
    style: {
      enableBackground: "new 0 0 171 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "santa-maria-feira"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.3,31.4l-8.7,25.3l-7.4-14L88.1,65.8v6h-8.2L66.2,31.4l-8.7,25.4l-7.4-14.1L39,65.8v33.6h10.1v49.2H57 V82.9L66.2,56l9.1,26.9v16.6h22.8v49.2h7.9V82.9l9.2-26.9l9.3,27.5L132,81L115.3,31.4z M46.9,91.5V67.7l3.5-7.3l3.6,6.8l-4.9,14.4 v10L46.9,91.5L46.9,91.5z M83.2,91.5v-10l-0.6-1.8H96v-12l3.5-7.3l3.5,6.7l-5,14.5v10L83.2,91.5L83.2,91.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 83.6,
    className: "st0",
    width: 7.9,
    height: 7.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.3,
    y: 83.6,
    className: "st0",
    width: 7.9,
    height: 7.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAveiro);
export default __webpack_public_path__ + "static/media/aveiro.4aead9f46b38a343131e29fc6f3784fc.svg";
export { ForwardRef as ReactComponent };